export const LOCALE_STORAGE_KEY = 'my-app-site-locale';
export const DEFAULT_LOCALE = 'zh-CN';
export const SUPPORTED_LOCALES = ['zh-CN', 'en'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

let currentApiLocale = 'zh';

export function getApiLocale(): 'zh' | 'en' {
  return currentApiLocale as 'zh' | 'en';
}

export function setApiLocale(locale: AppLocale) {
  currentApiLocale = locale.startsWith('en') ? 'en' : 'zh';
}

export function resolveStoredLocale(): AppLocale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && SUPPORTED_LOCALES.includes(stored as AppLocale)) {
    return stored as AppLocale;
  }
  const browser = navigator.language.toLowerCase();
  if (browser.startsWith('en')) return 'en';
  return DEFAULT_LOCALE;
}

export function persistLocale(locale: AppLocale) {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  setApiLocale(locale);
  document.documentElement.lang = locale;
}
